import { render, staticRenderFns } from "./CardType.vue?vue&type=template&id=3ae265d4&"
import script from "./CardType.vue?vue&type=script&lang=js&"
export * from "./CardType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports